import React, { useState, useEffect } from 'react'
import { Baseurl } from '../constants/env'
import axios from 'axios'
import QuillTextDisplay from './common/QuillTextDisplay'

import { useSelector } from "react-redux";
import {  useNavigate, NavLink, useLocation, Link } from 'react-router-dom';

const Tempfooter = (props) => {
  const location = useLocation()
   const [footerdata,setFooterdata] = useState([])
   const { totalcartitem } = useSelector((state) => state.cart);
   const navigate = useNavigate()
  const getfooter = async () => {
    let res = await axios(`${Baseurl}/footer`)
    if(res) setFooterdata(res?.data?.[0])
    if(props.phoneNumber){
      props.phoneNumber(res?.data?.[0]?.whatsappNumber)
    }
  } 
useEffect(() => {
  (async () => {
    if(location.pathname.includes('/product') || location.pathname === '/' ){
      // if(footerdata.length){
      //   return
      // }
      await getfooter()
    }
  })()
},[])
  return (
    <>
    <footer>




<div class="footer-bottom">
  <div class="container">



    <div class="row">
      <div class="col-md-4">

        {/* <img class="mb-3 w-50 " src={`${Baseurl}/view/imageupload/${footerdata.img}`} /> */}
        <img height={80} src="/images/logo.png" className='float-start' />

        <div className='clearfix'></div>
        <div class="w-100 footer-contact">
          {/* <p> <QuillTextDisplay text={footerdata.description} /> </p> */}
          <div class="d-flex mb-1">

          <img src="/images/contact-us/mail-icon.svg" class="me-2" /> <span>Imoxinfo@gmail.com</span>
        </div>
        <div class="d-flex mb-1">

          <img src="/images/contact-us/phone-icon.svg" class="me-2" /> <span>0501720250</span>
        </div>
        <div class="d-flex mb-3">

          <img src="/images/contact-us/map-icon.svg" class="me-2" /> <span>Industrial area 11, National paint, Sharjah</span>
        </div>
        </div>
        <div class=" social">

          {footerdata.facebook ? <a href={footerdata.facebook} target="_blank"> <i class="bi bi-facebook"></i></a> : <></> }
          {footerdata.instagram ? <a href={footerdata.instagram} target="_blank"> <i class="bi bi-instagram"></i></a> : <></> }
          {footerdata.youtube ? <a href={footerdata.youtube}  target="_blank"> <i class="bi bi-youtube"></i></a> : <></> }

        </div>
      </div>
      <div class="col-md-2 footer-links">

</div>

      <div class="col-md-4">

        <h5>Services</h5>

        <div class="footer-links">
          <ul>
            <li> <NavLink to="/contact">Contact Us</NavLink> </li>
            <li> <NavLink to="/blog">Blog</NavLink> </li>
            <li> <NavLink to="/about">About Us</NavLink> </li>
            <li> <NavLink to="/faq">FAQ</NavLink> </li>
          </ul>
        </div>

      </div>

      <div class="col-md-2">

        <h5>Quick Links</h5>

        <div class="footer-links">
          <ul>
            <li> <NavLink to="/terms">Terms And Conditions</NavLink> </li>
            <li> <NavLink to="/privacy">Privacy And Policy</NavLink> </li>
            {/* <li> <a href="#">Cookies</a> </li> */}
          </ul>
        </div>

      </div>
      {/* <div class="col-md-2">

        <h5>Quick Links</h5>

        <div class="footer-links">
          <ul>
            <li> <a href="#">Terms</a> </li>
            <li> <a href="#">Privacy</a> </li>
            <li> <a href="#">Cookies</a> </li>
          </ul>
        </div>

      </div> */}



      <div class="col-md-4 footer-links">

      </div>

    </div>




  </div>

</div>
<div class="copyright">

  <div class="container">
    <div class="row">
      <div class="col-md-6 d-flex align-items-center">
        <p>© imox kitchen All Rights Reserved</p>
      </div>

      <div class="col-md-6">

        <div class="d-flex align-items-center">

          {/* <p class="me-3 mb-0">Accept Cards</p>
          <img src="assets/images/home/accept-cards.png" /> */}
        </div>
     
      </div>
    </div>
  </div>
</div>



</footer>
      {/* <div className='row text-center text-white bg-dark'>
          <div className='col-sm-3 p-3'>
          <span className='fs-1' ><i className="bi bi-truck"></i></span> 
          <p>FREE SHIPPING</p>
          </div>
          <div className='col-sm-3 p-3'>
          <span className='fs-1' ><i className="bi bi-truck"></i></span> 
          <p>ONLINE PAYMENT</p>
          </div>
          <div className='col-sm-3 p-3'>
          <span className='fs-1' ><i className="bi bi-truck"></i></span> 
          <p>ONLINE SUPPORT</p>
          </div>
          <div className='col-sm-3 p-3'>
          <span className='fs-1' ><i className="bi bi-truck"></i></span> 
          <p>100% SAFE</p>
          </div>
        </div> */}

<a href="https://wa.me/971501720250?text=H" class="whatsap-link" target="_blank">
      <img width={20} src="/images/whatsap-white-icon.svg" />
    </a>

<div class="mobile-navbar d-flex justify-content-between">

    <Link to="/Shop" className={`${location.pathname === '/Shop' ? 'active' : ''}`}
                >
   <i class="bi bi-shop-window"></i>
    <p>Shop</p>
  </Link>


    <Link to="/Profile/wishlists" className={`${location.pathname === '/Profile/wishlists' ? 'active' : ''}`} >
  <i class="bi bi-heart"></i>
    <p>Wishlist</p>
  </Link>

  <Link to="/cart" className={`${location.pathname === '/cart' ? 'active' : ''}`} >
  <span className='badge'>{ totalcartitem }</span>
  <i class="bi bi-cart3"></i>
    <p>Cart</p>
  </Link>

  <Link to="/Profile" onClick={() => navigate('/Profile')} className={`${location.pathname === '/Profile' ? 'active' : ''}`}>
   <i class="bi bi-person"></i>
    <p>My Account</p>
  </Link>

  

</div>

    </>
  )
}

export default Tempfooter
